
const routes = [
    {
        path: "/asal",
        component: () => import("../pages/Index"),
        meta: { isAuthenticated: true,
              permission:'asal_index'
        }
    },

];

export default routes;
